<template>
  <div class="is-flex flex-align--center actions-container">
    <div class="has-text-grey update-master-label">
      Update Master:
    </div>
    <div class="buttons has-addons">
      <button
        v-for="option in [true, false]" :key=option
        class="button button--form is-small"
        :class="{ 'is-active': option === isYesActive }"
        @click="setUpdateMaster(option)">
        {{option ? 'Yes' : 'No'}}
      </button>
    </div>
  </div>
</template>

<script>

export default {
  emits: ['updateMasterChanged'],
  props: {
    potentialMatchId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      isYesActive: true,
    };
  },
  async created() {
    const s = this.$parent.doNotUpdateMasterIndicators;
    this.isYesActive = s && !s.has(this.potentialMatchId);
  },
  mounted() {
    this.$root.$on(this.refreshYesNoEventName, this.refreshYesNo);
  },
  destroyed() {
    this.$root.$off(this.refreshYesNoEventName);
  },
  computed: {
    refreshYesNoEventName() {
      return `refreshUpdateMasterYesNo${this.potentialMatchId}`;
    },
  },
  methods: {
    setUpdateMaster(doUpdate) {
      this.isYesActive = doUpdate;
      this.$emit('update-master-changed', {
        doUpdateOut: doUpdate,
        potentialMatchIdOut: this.potentialMatchId,
      });
      this.$root.$emit(this.refreshYesNoEventName, { doUpdateOut: doUpdate });
    },

    refreshYesNo(refreshParams) {
      this.isYesActive = refreshParams.doUpdateOut;
    },
  },
};
</script>
<style lang="sass" scoped>
  .actions-container
    margin-top: 1rem
  .update-master-label
    padding-right: 0.5rem
  button
    min-width: 50px
  .buttons.has-addons .button.is-active
      z-index: unset
</style>
